import React, { Component } from 'react';
import { connect } from 'react-redux';
import Drawer from '@material-ui/core/Drawer';
import UserHub from './UserHub';
import MemberList from './MemberList';

export class MainSideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      logoutClicked: false,
    };
  }

  //myCallbackLogout = (logoutClicked) => {
  //  console.log("logout clicked MainSideBar.js");
  //  if (logoutClicked) {
  //    this.setState({ logoutClicked: true });
  //  }
  //}

   render() {
    return (
      <div>
        <Drawer
          variant="permanent"
          anchor="left"
          PaperProps={{ style: { overflowY: 'unset' } }}
        >
          <UserHub /*callbackFromParentLogout={this.myCallbackLogout}*/ />
          <MemberList /*logoutClicked={this.state.logoutClicked}*/ />
        </Drawer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    members: state.members,
    profile: state.profile,
    currentUser: state.currentUser,
  };
}

export default connect(mapStateToProps, null)(MainSideBar);


// WEBPACK FOOTER //
// ./src/components/MainSideBar.js